import React, {ChangeEvent, useState} from "react"; //
import {useTranslation} from "react-i18next"; //
import style from "./Subject.module.css";

interface SubjectPropsDI {subject:string}

const Subject: React.FC<SubjectPropsDI> = (props) => {
  const {t} = useTranslation();

  return (
    <div tabIndex={1} id={t('Lesson-subject-text')} className={style.wrapper}>
      <h1 className={style.title}>{t('Lesson-subject-text')}</h1>
      <div className={style.separator}>
        <span></span>
      </div>
      <p tabIndex={1} className={style.content} title={props.subject}>
        {props.subject}
      </p>
    </div>
  );
};

// export default observer(LessonForm);
export default Subject;
